import { Box, Fade } from "@mui/material";
import { styled } from "@mui/material/styles";

export const AnimatedContainer = styled(Fade)(() => ({
  backgroundColor: "black",
  opacity: 0.95,
  borderRadius: "10px",
  position: "absolute",
  top: 0,
  left: 0,
  bottom: 0,
  right: 0
}));

export const RootContainer = styled(Box)(() => ({
  width: "100%",
  height: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  paddingLeft: "50px",
  paddingRight: "50px"
}));
